import React, { useState } from 'react';
import { createClient } from '@supabase/supabase-js'
import { toast } from 'react-toastify';
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3'

const WEB3_FORM_API_KEY = process.env.REACT_APP_WEB3_FORM_API_KEY;
const PROJECT_URL = process.env.REACT_APP_PROJECT_URL
const PROJECT_API_KEY = process.env.REACT_APP_PROJECT_API_KEY
const S3_ACCESS_KEY_ID = process.env.REACT_APP_S3_ACCESS_KEY_ID
const S3_ACCESS_SECRET_KEY = process.env.REACT_APP_S3_ACCESS_SECRET_KEY
const s3Endpoint = `${PROJECT_URL}/storage/v1/s3`

const supabase = createClient(PROJECT_URL, PROJECT_API_KEY)

const s3Client = new S3Client({
  forcePathStyle: true,
  region: 'ap-southeast-1',
  endpoint: s3Endpoint,
  credentials: {
    accessKeyId: S3_ACCESS_KEY_ID,
    secretAccessKey: S3_ACCESS_SECRET_KEY,
  }
})

const reportIssueFormData = {
  title: '',
  description: '',
}
function ReportIssueModal(props) {
  const [formData, setFormData] = useState(reportIssueFormData)
  const [selectedFile, setSelectedFile] = useState(null)

  const handleInputChange = (e) => {
    const newValue = e.target.value
    setFormData({
      ...formData,
      [e.target.name]: newValue,
    });
  }

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file)
      // const reader = new FileReader();

      // reader.onload = () => {
      //   const image = new Image();
      //   image.src = reader.result;
      // };

      // reader.readAsDataURL(file);
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (!selectedFile) {
      recordBug(event)
      return
    }
    try {
      let sanitizedFileName = selectedFile.name.trim().toLowerCase().replace(/\s+/g, '-');
      sanitizedFileName = sanitizedFileName.normalize('NFKD').replace(/[\u0300-\u036F]/g, '');
      sanitizedFileName = sanitizedFileName.replace(/[^a-z0-9\-\.]/g, '');
      const objectKey = sanitizedFileName
      const objectType = selectedFile.type
      const uploadPath = `issues/images/${objectKey}`
      const uploadCommand = new PutObjectCommand({
        Bucket: 'toolover',
        Key: uploadPath,
        Body: selectedFile,
        ContentType: objectType,
        ACL: 'public-read'
      })
      const res = await s3Client.send(uploadCommand)
      if (res) {
        const { data } = supabase
          .storage
          .from('toolover')
          .getPublicUrl(uploadPath)
        recordBug(event, data.publicUrl)
      }
    } catch (err) {
      console.error('Upload error:', err);
    }
  };

  const recordBug = async (event, imgUrl = null) => {
    const formData = new FormData(event.target);

    formData.append("access_key", WEB3_FORM_API_KEY);
    formData.delete("screenshot")
    if (imgUrl) {
      formData.append("screenshot", encodeURI(imgUrl))
    }
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      document.getElementById('close-modal').click()
      event.target.reset();
      setFormData(reportIssueFormData)
      toast.success('Your bug report was submitted successful!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      console.log("Error", data);
      toast.error(`Your bug report was submit failed!`, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  return (
    <>
      {/* Modal toggle */}
      <button
        id="report-issue-modal-btn"
        data-modal-target="crud-modal"
        data-modal-toggle="crud-modal"
        className="hidden text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        type="button"
      >
        Toggle modal
      </button>
      {/* Main modal */}
      <div
        id="crud-modal"
        tabIndex={-1}
        aria-hidden="true"
        className="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
      >
        <div className="relative p-4 w-full max-w-md max-h-full">
          {/* Modal content */}
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            {/* Modal header */}
            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Report Bug
              </h3>
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                data-modal-toggle="crud-modal"
                id="close-modal"
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            {/* Modal body */}
            <form id="report-issue-form" onSubmit={onSubmit} className="p-4 md:p-5">
              <div className="grid gap-4 mb-4 grid-cols-2">
                <div className="col-span-2">
                  <label
                    htmlFor="name"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Title
                  </label>
                  <input
                    type="text"
                    name="title"
                    id="report-issue-title"
                    value={formData.title}
                    onChange={handleInputChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Type your title"
                    required={true}
                  />
                </div>
                <div className="col-span-2">
                  <label
                    htmlFor="description"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Bug Description
                  </label>
                  <textarea
                    required={true}
                    id="report-issue-description"
                    name="description"
                    rows={4}
                    value={formData.description}
                    onChange={handleInputChange}
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Write your description here"
                  />
                </div>
                <div className="col-span-2">
                  <label
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    htmlFor="file_input"
                  >
                    Screenshot
                  </label>
                  <input
                    onChange={handleImageUpload}
                    className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                    aria-describedby="file_input_help"
                    id="file_input"
                    type="file"
                    name="screenshot"
                    accept="image/*"
                  />
                  <p
                    className="mt-1 text-sm text-gray-500 dark:text-gray-300"
                    id="file_input_help"
                  >
                    SVG, PNG, JPG or GIF (MAX. 800x400px).
                  </p>
                </div>
              </div>
              <button
                type="submit"
                // onClick={handleSubmit}
                disabled={!(formData.title && formData.description)}
                className="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReportIssueModal;
